module.exports = __webpack_public_path__ + "static/img/plan-task_01.b0c222fb.png";